
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyBarrelCross as ObiBuoyBarrelCrossElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-barrel-cross.js';
 
 
 

 
 export const ObiBuoyBarrelCross = createComponent({
   react: React,
   tagName: 'obi-buoy-barrel-cross',
   elementClass: ObiBuoyBarrelCrossElement,
   events: {
     
   }
  });
 
 